import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Foundations of UI/UX Design',
                topics: [
                    'Understanding Neomorphism',
                    'The Impact of Oversized Typography',
                    'Bold and Capitalized Typography',
                    'Best Practices for Mixing Fonts',
                    'Navigating Distorted Fonts',
                    'User-Centric Attention to Page Speed',
                ],
            },
            {
                title: 'User Accessibility and Experience',
                topics: [
                    'More Focus on Accessibility in UI/UX',
                    'Creating Flexible UI/UX Designs',
                    'Designing for Light Mode',
                    'Empty and Error States Illustration',
                    'Introduction to Design Systems',
                ],
            },
            {
                title: 'Data and Storytelling',
                topics: [
                    'Data Storytelling in UX',
                    'The Rise of Scrollytelling',
                    'Leveraging Data for Better User Experiences',
                    'Buttonless User Interfaces',
                    'The Minimum Lovable Product (MLP) Approach',
                ],
            },
        ],
        FourKeys_Advanced_item: [
            {
                title: 'Cutting-Edge Design and Interaction',
                topics: [
                    'Advanced Interactions and Animations',
                    'Exploring VR, AR, and Wearable UI Design',
                    'Advanced Microinteractions & Animations',
                    'Human-to-Computer Interaction (HCI)',
                ],
            },
            {
                title: 'Innovations in UI/UX',
                topics: [
                    'Voice User Interface (VUI) and Touchless Interactions',
                    'The Future of UX Writing and Microcopy',
                    'Emerging Trends in Interaction Design',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
                <div className='getReady_block getReady_advanced'>
                    <div></div>
                    {state.FourKeys_Advanced_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;